import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import localeFromPath from "./locales/fromPath";

import * as en from "./locales/en";
import * as es from "./locales/es";

const languageDetector = new LanguageDetector();

const fallbackLng = "en";

languageDetector.addDetector({
  name: "pathprefix",
  lookup: options =>
    typeof window !== "undefined"
      ? localeFromPath(window.location.pathname)
      : fallbackLng,
});

i18n
  .use(languageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng,
    load: "languageOnly",
    ns: ["translations"],
    defaultNS: "translations",
    detection: {
      order: ["pathprefix"],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en,
      es,
    },
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js